import { axiosApi } from "../../../../../../../api/dbAxios";

export const fetchUserGroupEmailList = async (payload: {
  group?: string;
  group_id?: string;
}) => {
  try {
    const params = new URLSearchParams();
    if (payload.group) params.append("group", payload.group);
    if (payload.group_id) params.append("group_id", payload.group_id);
    const { data } = await axiosApi.get("/email_group_users/", { params });
    return data;
  } catch (error) {
    console.error("Error fetching User Email Group list:", error);
    return [];
  }
};
